import { render, staticRenderFns } from "./MainEditor.vue?vue&type=template&id=088d75fa&scoped=true&"
import script from "./MainEditor.vue?vue&type=script&lang=js&"
export * from "./MainEditor.vue?vue&type=script&lang=js&"
import style0 from "./MainEditor.vue?vue&type=style&index=0&id=088d75fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d75fa",
  null
  
)

export default component.exports